var klaviyo = klaviyo || [];
klaviyo.init({
  account: "H8t5kD",
  platform: "shopify"
});

klaviyo.enable("backinstock",{
  trigger: {
  product_page_text: "Notify Me When Available",
  product_page_class: "btn",
  product_page_text_align: "center",
  product_page_margin: "0px",
  replace_anchor: false
  },
  modal: {
  headline: "{product_name}",
  body_content: "Enter your email and we'll let you know when it's back in stock.",
  email_field_label: "Email",
  button_label: "PING ME",
  subscription_success_label: "We got you, stay tuned!",
  footer_content: '',
  drop_background_color: "#000",
  background_color: "#fff",
  text_color: "#292b2c",
  button_text_color: "#292b2c",
  button_background_color: "#EF898D",
  close_button_color: "#000",
  error_background_color: "#fff",
  error_text_color: "#C72E2F",
  success_background_color: "#fff",
  success_text_color: "#1B9500",
      font_family: '"FuturaLTPro-Light"',
      additional_styles: '@import url(https://cdn.shopify.com/s/files/1/1991/8975/t/116/assets/webfonts.css?638256393395992766);body{font-size:12px;text-align:center}.btn{text-transform: uppercase;font-size:10px;opacity:0.5;letter-spacing:.1em;font-family: "Sackers Heavy Gothic";}.modal-title{color:#EF898D;font-size:25px;font-family: SilkSerif-Light;letter-spacing:.5px}'
  }
});
